import { useState } from "react";

export default function useValueName($default:any){
    
    
    const [vnState, setValueState] = useState($default);   



    const setValue = ($value:string | number | boolean, $name:string)=>{

        let newState = {...vnState};
        newState[$name]=$value; 
        setValueState(newState);
    }

    return [vnState,setValue, setValueState] as const;
    
}